<template>
  <v-skeleton-loader
    class="mx-auto"
    v-show="loading"
    :type="type"
    color="primary"
  ></v-skeleton-loader>
</template>

<script>
export default {
  name: "p-skeleton-loader",
  props: {
    loading: Boolean,
    type: String,
  },
};
</script>

<style scoped>
@import "./styles.css";
</style>
